import {initSvgIcon} from "../utils/icon";

$('.citations').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 1500,
    prevArrow : '<span class="arrow_prev arrow_slick"><svg data-icon="fleche"></svg></span>',
    nextArrow : '<span class="arrow_next arrow_slick"><svg data-icon="fleche"></svg></span>',
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
            }
        }
    ]
});
initSvgIcon();
